import { render } from "./lists.vue?vue&type=template&id=13b05564&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"

import "./lists.vue?vue&type=style&index=0&id=13b05564&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b05564"]])

export default __exports__